import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bbab901c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "top-grid-box"
}
const _hoisted_2 = { class: "top-grid-item-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "头像", -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "top-grid-item-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "昵称", -1))
const _hoisted_7 = { class: "top-grid-item-box" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "性别", -1))
const _hoisted_9 = { class: "top-grid-item-box" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "手机", -1))
const _hoisted_11 = { class: "top-grid-item-box" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "邀请人", -1))
const _hoisted_13 = { class: "top-grid-item-box" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "等级", -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "top-grid-item-box" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "付费会员", -1))
const _hoisted_19 = { class: "top-grid-item-box" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "注册时间", -1))
const _hoisted_21 = { class: "top-grid-item-box" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "激活时间", -1))
const _hoisted_23 = {
  key: 0,
  class: "bottom-grid-box"
}
const _hoisted_24 = { class: "bottom-grid-item-box" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "余额", -1))
const _hoisted_26 = { class: "bottom-grid-item-box" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "消费金额", -1))
const _hoisted_28 = { class: "bottom-grid-item-box" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "等级积分", -1))
const _hoisted_30 = { class: "coupon-tab-box" }
const _hoisted_31 = { class: "operat-style-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_title = _resolveComponent("ui-title")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_OrderList = _resolveComponent("OrderList")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_AmountLogList = _resolveComponent("AmountLogList")!
  const _component_ScoreLogList = _resolveComponent("ScoreLogList")!
  const _component_CouponList = _resolveComponent("CouponList")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_ui_container = _resolveComponent("ui-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ui_container, { class: "customer-detail-box" }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_ui_card, null, {
        title: _withCtx(() => [
          _createVNode(_component_ui_title, { title: "用户信息" })
        ]),
        default: _withCtx(() => [
          (_ctx.postData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("div", null, [
                    (_ctx.postData.avatar)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "avatar-box",
                          src: _ctx.postData.avatar
                        }, null, 8, _hoisted_4))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("--")
                        ], 64))
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("div", null, _toDisplayString(_ctx.postData.name || '--'), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", null, _toDisplayString(_ctx.getGender(_ctx.postData.gender)), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", null, _toDisplayString(_ctx.postData.phone || '--'), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", null, [
                    (_ctx.postData.inviterInfo)
                      ? (_openBlock(), _createBlock(_component_el_link, {
                          key: 0,
                          type: "primary",
                          onClick: _ctx.gotoInviter
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.postData.inviterInfo.name), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("--")
                        ], 64))
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", null, [
                    (_ctx.postData.levelInfo)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, " 级别" + _toDisplayString(_ctx.postData.levelInfo.level) + " (" + _toDisplayString(_ctx.postData.levelInfo.name) + ") ", 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_16, "--"))
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", null, _toDisplayString(_ctx.paidVipText), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", null, _toDisplayString(_ctx.postData.createTime ? _ctx.$format(_ctx.postData.createTime) : '--'), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("div", null, _toDisplayString(_ctx.postData.activeTime ? _ctx.$format(_ctx.postData.activeTime) : '--'), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })), [
        [_directive_loading, _ctx.loading]
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_ui_card, null, {
        title: _withCtx(() => [
          _createVNode(_component_ui_title, { title: "资产信息" }, {
            right: _withCtx(() => [
              (_ctx.postData)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    onClick: _ctx.adjustAmount
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("调整余额")
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.postData)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    onClick: _ctx.adjustScore
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("调整积分")
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          (_ctx.postData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("div", null, _toDisplayString(_ctx.postData.amount), 1)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("div", null, _toDisplayString(_ctx.postData.consumption), 1)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("div", null, _toDisplayString(_ctx.postData.score), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })), [
        [_directive_loading, _ctx.loading]
      ]),
      _createVNode(_component_ui_card, null, {
        title: _withCtx(() => [
          _createVNode(_component_ui_title, { title: "用户数据" })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_tabs, {
            modelValue: _ctx.activeTab,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
            type: "card",
            class: "detail-tab-box"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: "订单",
                name: "order",
                lazy: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_component_OrderList, {
                    key: `order-${_ctx.userId}`,
                    userId: _ctx.userId
                  }, null, 8, ["userId"]))
                ]),
                _: 1
              }),
              _createVNode(_component_el_tab_pane, {
                label: "余额流水",
                name: "amount",
                lazy: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_component_AmountLogList, {
                    ref: "amountLogList",
                    key: `amount-${_ctx.userId}`,
                    userId: _ctx.userId
                  }, null, 8, ["userId"]))
                ]),
                _: 1
              }),
              _createVNode(_component_el_tab_pane, {
                label: "积分流水",
                name: "score",
                lazy: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_component_ScoreLogList, {
                    ref: "scoreLogList",
                    key: `score-${_ctx.userId}`,
                    userId: _ctx.userId
                  }, null, 8, ["userId"]))
                ]),
                _: 1
              }),
              _createVNode(_component_el_tab_pane, {
                label: "优惠券",
                name: "coupon",
                lazy: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.sendCoupon
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("赠送优惠券")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    (_openBlock(), _createBlock(_component_CouponList, {
                      ref: "couponList",
                      key: `coupon-${_ctx.userId}`,
                      userId: _ctx.userId
                    }, null, 8, ["userId"]))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}